<template>
    <div >
        <participant-details-card v-if="showDetails"
                                    v-model="model"
                                    :files="files">
        </participant-details-card>
    </div>
</template>

<script>
    import { Participant } from '../../../models/models';
    import ParticipantDetailsCard from '../../../components/participants/ParticipantDetailsCard';
    import { FileDetails } from "@/models/file.models";

    export default {
        components: {
            ParticipantDetailsCard
        },
        data() {
            return {
                id: '',
                showDetails: true,
                files: [],
                model: new Participant(),
                loading: false
            };
        },
        methods: {
            loadData() {
                this.loading = true;
                this.$http.get(`/api/Participant/${this.id}`).then(result => {
                    this.model = new Participant(result.data);
                    this.loading = false;
                }).catch(error => {
                    // TODO:
                });
            },
            loadFiles() {
                this.$http.get(`/api/participant/participationFiles/${this.id}`)
                .then(result => {
                    if (result.data) {
                        result.data.forEach(file => {
                            this.files.push(new FileDetails(file));
                        })
                    }
                }).catch(error => {
                    // TODO:
                })
            }
        },
        watch: {
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.id) {
                this.loadData();
                this.loadFiles();
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
